import React, { useEffect, useState } from 'react'
import { ChartTitle, Flex, Spinner } from '../../Components'
import { Api, formatPrice, getQueryParams } from '../Functions'

const headerKeys = ['Origin', 'Amount', 'Pax nr.', 'Avg. Price']
const keys = ['Origin', 'Costo_Totale', 'N_Pax_Totali', 'Costo_medio_per_pax']

export const YourPreferredTop20Origins = () => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [data, setData] = useState()

  const loadTop20PreferredOriginsYTD = async () => {
    const { data: { data } } = await Api()('biDB/getTop20PreferredOriginsYTD', { params: { ...getQueryParams() } })
    setData(data)
    setIsSuccess(true)
  }

  useEffect(() => { loadTop20PreferredOriginsYTD() }, [])

  if (!isSuccess) return <Spinner />
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <Flex fw fh style={{ padding: '0px 10%' }} row>
        <ChartTitle
          title='Your preferred Top 20 Origins' style={{ padding: 0, paddingRight: '5%' }}
          subTitle='A list of the most chosen airports of origin for your company, reporting the total YTD cost and the avrage ticket price associated.'
        />
        <OriginsTable data={data} />
      </Flex>
    </div>
  )
}

const OriginsTable = ({ data }) => {
  const Top10TotalAmount = data.reduce((acc, item, index) => index < (data?.length - 1) ? acc + parseFloat(item.Costo_Totale) : acc, 0)
  const OtherTotalAmount = (parseFloat(data[data?.length - 1].CostoTotale) - Top10TotalAmount)

  const Top10TotalPax = data.reduce((acc, item, index) => index < (data?.length - 1) ? acc + parseFloat(item.N_Pax_Totali) : acc, 0)
  const OtherTotalPax = (parseInt(data[data?.length - 1].TotalePax) - Top10TotalPax)

  return (
    <>
      <table>
        {!!headerKeys?.length && (
          <thead>
            <tr>
              <td colSpan='2' style={{ border: '0px' }} />
              <td colSpan='3' style={{ backgroundColor: 'silver', color: '#FFF' }}>Year to date figures</td>
            </tr>
            <tr>
              <td>#</td>
              {headerKeys.map((key) => (
                <td className='firstRow' key={key}>{key}</td>
              ))}
            </tr>
          </thead>)}
        <tbody>
          {data.map((item, index) => index < (data?.length - 1) && (
            <tr key={index}>
              <td>{index + 1}</td>
              {keys.map((key, keyN) =>
                <td key={key}>
                  {keyN === 1 || keyN === 3 ? formatPrice(item[key]) : item[key]}
                </td>)}
            </tr>
          ))}
          <tr>
            <td />
            <td> OTHERS </td>
            <td> {formatPrice(OtherTotalAmount)} </td>
            <td> {OtherTotalPax || 0} </td>
            <td> {formatPrice(OtherTotalAmount && OtherTotalPax ? (OtherTotalAmount / OtherTotalPax) : 0)} </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
